import React from "react";
import { getWorkflowActions } from "../../config/rbacConfig";

export default function WorkflowActions({ status, permissions, onAction, compact = false }) {
  const actions = getWorkflowActions(permissions, status);
  if (!actions.length) return null;

  return (
    <div className={`flex flex-wrap ${compact ? "gap-1.5" : "gap-2"}`}>
      {actions.map((action) => (
        <button
          key={action.key}
          type="button"
          onClick={() => onAction(action.key)}
          className={`rounded-lg border text-xs font-semibold transition-colors ${
            action.key === "reject"
              ? "border-red-200 bg-red-50 text-red-600 hover:bg-red-100"
              : "border-green-200 bg-green-50 text-green-700 hover:bg-green-100"
          } ${compact ? "px-2.5 py-1.5" : "px-3 py-2"}`}
        >
          {action.label}
        </button>
      ))}
    </div>
  );
}
